import { render, staticRenderFns } from "./LaudosDashboard.vue?vue&type=template&id=48f6e7ca&scoped=true&lang=pug"
import script from "./LaudosDashboard.vue?vue&type=script&lang=js"
export * from "./LaudosDashboard.vue?vue&type=script&lang=js"
import style0 from "./LaudosDashboard.vue?vue&type=style&index=0&id=48f6e7ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f6e7ca",
  null
  
)

export default component.exports